<template>
  <sfs-form-modal
    :id="modalId"
    title="Add a Commission"
    @on-hide="resetFormData"
  >
    <commissions-form
      :location_id="location_id"
      @on-submit="createCommission"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import CommissionsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'CommissionsAddModal',
  mixins: [formModalMixin],
  components: {
    CommissionsForm,
  },
  props: {
    location_id: Number,
  },
  data() {
    return {
      modalId: 'commissions-add-modal',
    };
  },
  methods: {
    createCommission(data, handleCreate) {
      handleCreate(this.$commissionsAPI.create(data));
    },
    onSave() {
      this.closeModal();
      this.$emit('save');
    },
  },
};
</script>
